var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5022_17015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8801 5.19645L18.4082 3.72452C18.332 3.64829 18.2286 3.60547 18.1207 3.60547C18.0129 3.60547 17.9095 3.64829 17.8333 3.72452L10.2587 11.2987L7.55656 8.59674C7.48031 8.52051 7.3769 8.47769 7.26908 8.47769C7.16126 8.47769 7.05786 8.52051 6.98161 8.59674L5.50968 10.0687C5.43345 10.1449 5.39062 10.2483 5.39062 10.3561C5.39062 10.464 5.43345 10.5674 5.50968 10.6436L9.97122 15.1048C10.0507 15.1843 10.1546 15.2239 10.2587 15.2239C10.363 15.2239 10.4665 15.1843 10.5462 15.1048L19.8799 5.7714C19.9562 5.69518 19.999 5.59179 19.9991 5.48397C19.9991 5.37615 19.9563 5.27273 19.8801 5.19645Z",
    fill: "url(#paint0_linear_5022_17015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9598 16.9601H2.03306V4.03306H15.2679L16.9929 2.40661C16.9929 2.29877 16.9501 2.19535 16.8738 2.11909C16.7976 2.04284 16.6941 2 16.5863 2H0.406612C0.298771 2 0.195348 2.04284 0.119094 2.11909C0.0428393 2.19535 0 2.29877 0 2.40661L0 18.5865C0 18.6943 0.0428393 18.7978 0.119094 18.874C0.195348 18.9503 0.298771 18.9931 0.406612 18.9931H16.5865C16.6943 18.9931 16.7978 18.9503 16.874 18.874C16.9503 18.7978 16.9931 18.6943 16.9931 18.5865V10.8853L14.9601 13.02L14.9598 16.9601Z",
    fill: "url(#paint1_linear_5022_17015)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5022_17015",
    x1: 12.6949,
    y1: 3.60547,
    x2: 12.6949,
    y2: 15.2239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5022_17015",
    x1: 8.49655,
    y1: 2,
    x2: 8.49655,
    y2: 18.9931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5022_17015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.166016)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareCheckbox);
export default __webpack_public_path__ + "static/media/square-checkbox.1e67d8cf6965d70057db8cfa22d6a49a.svg";
export { ForwardRef as ReactComponent };